export const suppressDirective = {
    mounted(el: HTMLElement, binding: { value?: boolean }) {
        applySuppression(el, binding.value);
    },
    updated(el: HTMLElement, binding: { value?: boolean }) {
        applySuppression(el, binding.value);
    },
};

function applySuppression(el: HTMLElement, value?: boolean) {
    const shouldSuppress = value ?? true;
    if (shouldSuppress) {
        el.setAttribute('data-clarity-mask', 'true');
        el.setAttribute('data-hj-suppress', '');
    } else {
        el.removeAttribute('data-clarity-mask');
        el.removeAttribute('data-hj-suppress');
    }
}
